package com.dotdrives.web.pages.settings

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

private val settingsStyles = """
    .settings-section-card { margin-bottom: 18px; }
    .settings-section-card form { display: flex; flex-wrap: wrap; align-items: end; gap: 12px; }
    .settings-section-card label { display: inline-flex; flex-direction: column; gap: 6px; font-size: 13px; font-weight: 700; margin: 12px 12px 12px 0; max-width: 100%; }
    .settings-section-card input:not([type=checkbox]), .settings-section-card select { min-height: 42px; max-width: 100%; width: 240px; padding: 9px 12px; border: 1px solid #CBD2D7; border-radius: 9px; background: white; color: #222D32; font: inherit; }
    .settings-section-card label:has(input[type=checkbox]) { flex-direction: row; align-items: center; width: auto; gap: 8px; }
    .settings-phase-row { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin: 8px 0; }
    .settings-section-card input[type=checkbox] { width: 20px; height: 20px; }
    .settings-section-card .dot-button { margin: 6px 8px 6px 0; }
    .settings-section-card form > button { min-height: 42px; padding: 10px 16px; border-radius: 99px; background: #222D32; color: white; font-weight: 800; cursor: pointer; }
    .settings-section-card form > button:disabled { opacity: .55; cursor: default; }
    .settings-section-card :focus-visible { outline: 3px solid #222D32; outline-offset: 3px; }
    .settings-invite-row { flex-wrap: wrap; overflow-wrap: anywhere; }
    .settings-section-subtitle { line-height: 1.5; }
    @media (max-width: 600px) { .settings-section-card label { display: flex; width: 100%; margin-right: 0; } .settings-section-card input:not([type=checkbox]), .settings-section-card select { width: 100%; } }
    .settings-page { min-height: calc(100vh - 118px); }
    .settings-tabs { display: flex; gap: 2px; margin-bottom: 18px; flex-wrap: wrap; }
    .settings-tab {
      padding: 9px 16px; border-radius: 99px; color: var(--dot-muted); background: transparent;
      cursor: pointer; font-size: 13px; font-weight: 800;
    }
    .settings-tab-active { color: #fff; background: #222D32; }
    .settings-tab-disabled { color: #C4CBD1; cursor: not-allowed; }
    .settings-inline-banner { margin-bottom: 14px; }
    .settings-billing-banner { margin-bottom: 18px; }
    .settings-actions-row { display: flex; justify-content: flex-end; margin-bottom: 12px; }

    .settings-users-grid { min-width: 0; display: grid; grid-template-columns: minmax(0, 1fr) 380px; gap: 18px; align-items: start; }
    .settings-user-list-head {
      display: grid; grid-template-columns: 1.8fr 1.3fr 1fr 0.6fr; padding: 0 16px 8px;
      font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: var(--dot-muted);
    }
    .settings-user-list { min-width: 0; display: flex; flex-direction: column; gap: 8px; }
    .settings-user-row {
      width: 100%; display: grid; grid-template-columns: 1.8fr 1.3fr 1fr 0.6fr; align-items: center;
      background: white; border: 1px solid #E4E8EC; border-radius: 12px; padding: 12px 16px;
      cursor: pointer; text-align: left; transition: border-color 140ms ease;
    }
    .settings-user-row:hover, .settings-user-row-selected { border-color: #F26223; }
    .settings-user-identity { min-width: 0; display: flex; align-items: center; gap: 11px; }
    .settings-user-name { min-width: 0; overflow-wrap: anywhere; font-weight: 800; font-size: 13.5px; }
    .settings-user-role-cell { display: flex; }
    .settings-user-goal { font-family: 'IBM Plex Mono', monospace; font-size: 12px; }
    .settings-user-goal-empty { color: var(--dot-muted); }
    .settings-user-active { font-size: 12px; color: var(--dot-muted); text-align: right; }

    .settings-section-card {
      background: white; border: 1px solid #E4E8EC; border-radius: 16px; padding: 20px; height: fit-content;
    }
    .settings-section-title { font-family: 'Quicksand', sans-serif; font-size: 16px; font-weight: 700; margin-bottom: 4px; }
    .settings-section-subtitle { font-size: 12.5px; color: var(--dot-muted); margin-bottom: 16px; }
    .settings-perm-row {
      display: flex; align-items: center; justify-content: space-between; padding: 7px 0;
      border-bottom: 1px solid #F2F4F6;
    }
    .settings-perm-name { font-size: 13px; font-weight: 700; }
    .settings-perm-pills { display: flex; gap: 6px; }
    .settings-perm-pill {
      font-size: 10px; font-weight: 800; padding: 3px 10px; border-radius: 99px;
      background: #EFF1F4; color: var(--dot-muted);
    }
    .settings-perm-pill-on { background: #E3F1E8; color: #007942; }

    .settings-invites-card { margin-top: 18px; }
    .settings-invite-row {
      display: flex; align-items: center; gap: 11px; padding: 10px 0; border-bottom: 1px solid #F2F4F6;
    }
    .settings-invite-row:last-child { border-bottom: none; }
    .settings-invite-copy { flex: 1; min-width: 0; }
    .settings-invite-email { font-weight: 800; font-size: 13px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .settings-invite-meta { font-size: 11px; color: var(--dot-muted); margin-top: 1px; }
    .settings-team-management-note {
      margin-top: 12px; padding: 10px 12px; border-radius: 10px; background: #F7F8FA;
      color: var(--dot-muted); font-size: 11px; line-height: 1.5;
    }

    .settings-panel-row { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px; margin-bottom: 18px; }
    .settings-integration-row {
      display: flex; align-items: center; gap: 10px; border: 1px solid #E4E8EC; border-radius: 10px;
      padding: 10px 13px; margin-bottom: 8px;
    }
    .settings-integration-row:last-child { margin-bottom: 0; }
    .settings-integration-row-connected { border-color: #BDE3BD; background: #EDF7ED; }
    .settings-integration-icon {
      width: 22px; height: 22px; border-radius: 5px; color: #fff; font-weight: 900; font-size: 11px;
      display: flex; align-items: center; justify-content: center; flex: 0 0 auto;
    }
    .settings-integration-copy { flex: 1; min-width: 0; }
    .settings-integration-name { font-weight: 800; font-size: 12.5px; }
    .settings-integration-status { font-size: 10.5px; margin-top: 1px; }
    .settings-integration-status-on { color: #1E7B1E; }
    .settings-integration-status-off { color: var(--dot-muted); }
    .settings-integration-manage {
      font-size: 11px; font-weight: 800; color: #F26223; background: transparent; cursor: pointer;
    }
    .settings-integration-manage:disabled { color: var(--dot-muted); cursor: not-allowed; }

    .settings-billing-card { background: #222D32; color: #fff; border-radius: 16px; padding: 20px; }
    .settings-billing-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
    .settings-billing-title { font-family: 'Quicksand', sans-serif; font-size: 15px; font-weight: 700; }
    .settings-billing-plan { font-family: 'Quicksand', sans-serif; font-size: 28px; font-weight: 700; }
    .settings-billing-meta { font-family: 'IBM Plex Mono', monospace; font-size: 12.5px; color: #8FA0AA; margin-bottom: 14px; }
    .settings-billing-limits { display: flex; flex-direction: column; gap: 7px; font-size: 12.5px; color: #C9D3D9; }
    .settings-billing-actions { margin-top: 16px; display: flex; gap: 8px; }
    .settings-billing-action {
      flex: 1; text-align: center; font-size: 12px; font-weight: 800; padding: 9px; border-radius: 99px;
      background: rgba(255,255,255,.1); color: #fff; cursor: pointer;
    }
    .settings-billing-action-primary { background: var(--dot-action); }
    .settings-billing-action:disabled { cursor: not-allowed; opacity: .5; }
    .settings-billing-denied {
      background: white; border: 1px solid #E4E8EC; border-radius: 16px; padding: 24px; text-align: center;
      color: #5A6870; font-size: 13px;
    }

    .settings-budget-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; }
    .settings-budget-card { border: 1px solid #E4E8EC; border-radius: 12px; padding: 14px 16px; }
    .settings-budget-label {
      font-family: 'IBM Plex Mono', monospace; font-size: 10px; color: var(--dot-muted); letter-spacing: 1px; margin-bottom: 5px;
    }
    .settings-budget-value { font-family: 'Quicksand', sans-serif; font-size: 21px; font-weight: 700; }
    .settings-budget-sub { font-size: 11.5px; font-weight: 700; margin-top: 2px; }
    .settings-budget-card-title-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }
    .settings-budget-add {
      margin-top: 12px; font-size: 12.5px; font-weight: 800; color: #F26223; background: transparent; cursor: pointer;
    }
    .settings-steward-list { display: flex; flex-direction: column; gap: 8px; margin-top: 14px; }
    .settings-steward-row { display: flex; align-items: center; justify-content: space-between; padding: 8px 0; border-bottom: 1px solid #F2F4F6; }
    .settings-steward-row:last-child { border-bottom: none; }
    .settings-steward-name { font-size: 13px; font-weight: 700; }
    .settings-steward-amount { font-family: 'IBM Plex Mono', monospace; font-size: 12.5px; color: #5A6870; }
    .settings-scope-note {
      margin-top: 14px; padding: 11px 14px; border-radius: 11px; background: #F7F8FA; color: #5A6870; font-size: 11.5px;
    }

    .settings-tag-row { display: flex; flex-wrap: wrap; gap: 8px; }
    .settings-tag-pill { font-size: 12px; font-weight: 800; padding: 6px 13px; border-radius: 99px; }
    .settings-tag-add {
      border: 1.5px dashed #D6DBE0; color: var(--dot-muted); font-size: 12px; font-weight: 800;
      padding: 6px 13px; border-radius: 99px; background: transparent; cursor: pointer;
    }
    .settings-tag-add:hover { border-color: #F26223; color: var(--dot-action-text); }
    .settings-tag-color-row { display: flex; gap: 8px; }
    .settings-tag-swatch {
      width: 30px; height: 30px; border-radius: 50%; border: 2px solid transparent; cursor: pointer;
    }
    .settings-tag-swatch-selected { border-color: #222D32; }

    .settings-dialog-backdrop {
      position: fixed; z-index: 40; inset: 0; display: flex; align-items: center; justify-content: center;
      padding: 24px; background: rgba(34,45,50,.34); animation: settings-fade-in 180ms ease both;
    }
    .settings-dialog {
      width: min(500px, 100%); max-height: calc(100vh - 48px); overflow: auto; padding: 26px 30px;
      border-radius: 20px; background: white; box-shadow: 0 24px 80px rgba(34,45,50,.25);
      animation: settings-pop-in 220ms ease both;
    }
    .settings-dialog-title { font-family: 'Quicksand', sans-serif; font-size: 20px; font-weight: 700; margin-bottom: 14px; }
    .settings-form-field { display: grid; gap: 5px; margin-bottom: 14px; }
    .settings-form-label { font-size: 12px; font-weight: 800; }
    .settings-dialog input, .settings-dialog select {
      width: 100%; padding: 10px 12px; border: 1px solid #E4E8EC; border-radius: 10px;
      outline: none; color: #222D32; background: white; font-size: 13px;
    }
    .settings-dialog input:focus, .settings-dialog select:focus { border-color: #F26223; }
    .settings-role-options { display: flex; flex-direction: column; gap: 8px; margin-bottom: 14px; }
    .settings-role-option {
      width: 100%; border: 1px solid #E4E8EC; background: white; border-radius: 12px; padding: 11px 14px;
      display: flex; align-items: center; gap: 11px; cursor: pointer; text-align: left;
    }
    .settings-role-option-selected { border: 2px solid #F26223; background: #FEF8F6; padding: 10px 13px; }
    .settings-role-option-copy { flex: 1; min-width: 0; }
    .settings-role-option-name { font-weight: 800; font-size: 13px; }
    .settings-role-option-desc { font-size: 11px; color: var(--dot-muted); margin-top: 1px; }
    .settings-role-option-check { color: #F26223; font-weight: 900; }
    .settings-dialog-note {
      background: #F7F8FA; border-radius: 11px; padding: 11px 14px; font-size: 12px; color: #5A6870; margin-bottom: 16px;
    }
    .settings-dialog-actions { display: flex; gap: 10px; margin-top: 6px; }
    .settings-dialog-actions > * { flex: 1; }
    .settings-form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }


    .process-configuration { max-width: 1100px; color: #222D32; font-family: 'Nunito', sans-serif; }
    .process-configuration h2, .process-configuration h3, .process-configuration h4, .process-configuration p { margin: 0; }
    .process-configuration h2 { font-size: 22px; line-height: 1.3; font-weight: 800; }
    .process-configuration h3 { font-size: 20px; line-height: 1.4; font-weight: 800; overflow-wrap: anywhere; }
    .process-heading { display: flex; align-items: center; justify-content: space-between; gap: 20px; margin: 26px 0 24px; }
    .process-heading p { margin-top: 5px; color: var(--dot-muted); font-size: 14px; line-height: 1.5; }
    .process-heading .dot-button { flex-shrink: 0; }
    .process-layout { display: grid; grid-template-columns: minmax(180px, 240px) minmax(0, 1fr); align-items: start; gap: 24px; }
    .process-navigation { display: grid; gap: 4px; }
    .process-navigation-item { display: grid; gap: 4px; min-height: 68px; padding: 13px 16px; border-left: 3px solid transparent; border-radius: 0 10px 10px 0; text-align: left; background: transparent; color: #222D32; cursor: pointer; }
    .process-navigation-item:hover:not(:disabled) { background: #E9EDF0; }
    .process-navigation-selected { background: white; border-left-color: var(--dot-action); }
    .process-navigation-item:disabled { cursor: default; }
    .process-navigation-name { font-size: 15px; font-weight: 800; overflow-wrap: anywhere; }
    .process-meta { color: var(--dot-muted); font-size: 13px; line-height: 1.5; }
    .process-workspace { min-width: 0; min-height: 270px; border: 1px solid #E4E8EC; border-radius: 14px; background: white; overflow: hidden; }
    .process-workspace-heading { display: flex; align-items: center; justify-content: space-between; gap: 18px; padding: 24px; }
    .process-workspace-heading .dot-button { min-height: 40px; padding: 9px 17px; white-space: nowrap; }
    .process-phase-list { list-style: none; margin: 0; padding: 0 24px; }
    .process-phase { display: flex; align-items: center; gap: 14px; min-height: 72px; padding: 14px 0; border-top: 1px solid #E4E8EC; }
    .process-phase-order { flex: 0 0 28px; color: var(--dot-muted); font-size: 14px; text-align: center; font-variant-numeric: tabular-nums; }
    .process-phase-copy { display: flex; align-items: center; gap: 9px; flex-wrap: wrap; flex: 1; min-width: 0; }
    .process-phase-name { font-size: 15px; font-weight: 800; overflow-wrap: anywhere; }
    .process-closing { padding: 3px 8px; border-radius: 5px; color: #43515A; background: #EFF1F4; font-size: 11px; font-weight: 800; }
    .process-edit-button { min-height: 40px; padding: 8px 12px; background: transparent; color: #43515A; cursor: pointer; font-size: 13px; font-weight: 800; border-radius: 8px; }
    .process-edit-button:hover { background: #EFF1F4; }
    .process-footnote { padding: 20px 24px 24px; color: var(--dot-muted); font-size: 12px; line-height: 1.6; }
    .process-empty { padding: 24px; }
    .process-empty h4 { font-size: 17px; font-weight: 800; }
    .process-empty p { max-width: 420px; margin: 7px 0 20px; color: var(--dot-muted); font-size: 14px; line-height: 1.6; }
    .process-editor-body { padding: 26px; }
    .process-editor-body > .process-meta { margin: 4px 0 24px; }
    .process-editor label { display: block; margin: 18px 0 7px; font-size: 13px; font-weight: 800; }
    .process-editor input:not([type=checkbox]) { width: 100%; min-height: 46px; padding: 10px 12px; border: 1px solid #BFC8CE; border-radius: 8px; color: #222D32; background: white; font-size: 15px; }
    .process-editor input.process-order-input { max-width: 110px; }
    .process-editor .process-closing-field { display: flex; align-items: center; gap: 9px; margin-top: 24px; }
    .process-closing-field input { width: 18px; height: 18px; margin: 0; accent-color: var(--dot-action); }
    .process-field-help { max-width: 470px; margin-top: 7px !important; color: var(--dot-muted); font-size: 12px; line-height: 1.6; }
    .process-editor-footer { display: flex; justify-content: flex-end; gap: 10px; padding: 18px 26px; background: #F7F8FA; border-top: 1px solid #E4E8EC; }
    .process-loading { margin-bottom: 12px; color: var(--dot-muted); font-size: 13px; }
    .process-saved { margin-bottom: 16px; color: var(--dot-positive); font-size: 14px; font-weight: 800; }
    .process-phase-saved { animation: process-saved-reveal 1.8s ease-out; }
    .process-configuration :focus-visible { outline: 2px solid var(--dot-focus); outline-offset: 3px; }
    @keyframes process-saved-reveal { from { background: #E3F1E8; } to { background: transparent; } }
    @media (prefers-reduced-motion: reduce) { .process-phase-saved { animation: none; } }
    @media (max-width: 800px) {
      .process-layout { grid-template-columns: 1fr; gap: 16px; }
      .process-navigation { grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); }
      .process-heading { align-items: flex-start; flex-wrap: wrap; margin-top: 18px; }
    }
    @media (max-width: 480px) {
      .process-workspace-heading { flex-wrap: wrap; padding: 18px; }
      .process-phase-list { padding: 0 18px; }
      .process-phase { gap: 8px; }
      .process-phase-order { flex-basis: 20px; }
      .process-editor-body, .process-empty { padding: 20px 18px; }
      .process-editor-footer { padding: 16px 18px; }
      .process-editor-footer > * { flex: 1; padding-inline: 12px; }
      .process-footnote { padding: 18px; }
    }

    .settings-section-card { margin-bottom: 24px; padding: 24px; min-width: 0; }
    .settings-nav-group { display: flex; align-items: center; gap: 6px; }
    .settings-nav-group-title { padding: 0 8px; color: var(--dot-muted); font-size: 12px; font-weight: 800; }
    .settings-goal-actions { display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap; margin: 18px 0; }
    .settings-goal-actions label { display: flex; align-items: center; gap: 8px; font-size: 14px; font-weight: 700; }
    .settings-goal-progress { margin-top: 6px; color: #43515A; font-size: 13px; font-variant-numeric: tabular-nums; }
    .settings-fiscal-grid { max-width: 360px; margin: 18px 0; }
    .settings-member-sheet { position: fixed; inset: 0 0 0 auto; width: min(520px, 100%); max-height: 100dvh; height: 100dvh; border-radius: 0; overflow-y: auto; }
    .settings-sheet-close { float: right; border: 0; background: transparent; min-width: 44px; min-height: 44px; font-size: 26px; cursor: pointer; }
    .settings-section-title { font-family: 'Nunito', sans-serif; font-size: 22px; line-height: 1.3; font-weight: 800; }
    .settings-section-subtitle { font-size: 14px; line-height: 1.5; }
    .settings-section-card input:not([type=checkbox]), .settings-section-card select { min-height: 46px; min-width: 0; box-sizing: border-box; }
    .settings-section-card label { min-width: 0; }
    .settings-users-grid { gap: 24px; margin-bottom: 24px; }
    .settings-user-list-head, .settings-user-row { grid-template-columns: minmax(0, 1fr) 140px; gap: 12px; }
    .settings-users-with-goals .settings-user-list-head, .settings-users-with-goals .settings-user-row { grid-template-columns: minmax(0, 1fr) 120px 100px; }
    .settings-user-list-head { font-family: inherit; font-size: 12px; font-weight: 800; }
    .settings-user-row:focus-visible, #settings-member-detail:focus-visible { outline: 3px solid var(--dot-focus); outline-offset: 3px; }
    .settings-user-identity > div { min-width: 0; }
    .settings-perm-row { gap: 10px; flex-wrap: wrap; }
    .settings-section-card .settings-focused-form { display: grid; align-items: stretch; gap: 16px; max-width: 640px; margin: 20px 0; }
    .settings-focused-form label { margin: 0; width: 100%; display: flex; }
    .settings-focused-form input:not([type=checkbox]), .settings-focused-form select { width: 100%; }
    .settings-focused-form .settings-section-subtitle { margin: 0; }
    .settings-editor-actions { display: flex; flex-wrap: wrap; justify-content: flex-end; align-items: center; gap: 10px; padding-top: 16px; border-top: 1px solid #E4E8EC; }
    .settings-editor-actions .dot-button { margin: 0; min-height: 44px; }
    .settings-section-card form > .dot-button-primary { background: var(--dot-action); }
    .settings-section-card form > .dot-button-secondary { background: #EFF1F4; color: #222D32; }
    .settings-saved { color: #007942; padding: 12px 0; font-size: 14px; font-weight: 800; }
    .settings-access-removal { margin-top: 24px; border-top: 1px solid #E4E8EC; padding-top: 18px; }
    .settings-access-removal h3 { font-size: 16px; margin: 0 0 8px; }
    .settings-access-removal p { font-size: 14px; line-height: 1.5; color: var(--dot-muted); }
    .settings-access-removal label { width: 100%; margin-right: 0; }
    .settings-access-removal select { width: 100%; }
    .settings-target-row { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; padding: 18px 0; border-top: 1px solid #E4E8EC; }
    .settings-target-copy { flex: 1; min-width: 160px; overflow-wrap: anywhere; }
    .settings-target-name { font-weight: 800; font-size: 16px; }
    .settings-target-row .settings-section-subtitle { margin: 5px 0 0; }
    .settings-target-amount { font-variant-numeric: tabular-nums; font-weight: 800; }
    .settings-status-pill { border-radius: 99px; padding: 5px 10px; background: #EFF1F4; color: #43515A; font-size: 12px; font-weight: 800; }
    .settings-invite-email { white-space: normal; overflow-wrap: anywhere; }
    .settings-invite-meta { font-size: 13px; line-height: 1.5; }
    .settings-form-grid > * { min-width: 0; }
    .settings-dialog input, .settings-dialog select { box-sizing: border-box; min-width: 0; min-height: 44px; }
    .settings-dialog :focus-visible { outline: 3px solid var(--dot-focus); outline-offset: 2px; }
    .settings-tag-color-row { flex-wrap: wrap; }
    .settings-item-saved { animation: process-saved-reveal 1.8s ease-out; }
    @media (max-width: 600px) {
      .settings-tabs { align-items: stretch; }
      .settings-nav-group { flex-direction: column; align-items: stretch; }
      .settings-nav-group-title { padding-top: 10px; }
      .settings-user-list-head { display: none; }
      .settings-user-row, .settings-users-with-goals .settings-user-row { grid-template-columns: minmax(0, 1fr) auto !important; }
      .settings-user-identity { grid-column: 1 / -1; }
      .settings-section-card { padding: 20px; }
      .settings-target-copy { flex-basis: 100%; min-width: 0; }
    }
    @media (max-width: 400px) {
      .settings-section-card { padding: 18px 14px; }
      .settings-goal-actions > * { width: 100%; }
      .settings-dialog-backdrop { padding: 12px; }
      .settings-dialog { padding: 20px 16px; max-height: calc(100dvh - 24px); }
      .settings-form-grid { grid-template-columns: minmax(0, 1fr); gap: 16px; }
      .settings-editor-actions { justify-content: stretch; }
      .settings-editor-actions > * { flex: 1; padding-inline: 10px; }
    }
    @media (prefers-reduced-motion: reduce) { .settings-item-saved, .settings-dialog, .settings-dialog-backdrop { animation: none; } }

    @keyframes settings-fade-in { from { opacity: 0; } to { opacity: 1; } }
    @keyframes settings-pop-in {
      from { transform: translateY(14px); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }

    @media (max-width: 980px) {
      .settings-users-grid { grid-template-columns: 1fr; }
      .settings-panel-row { grid-template-columns: 1fr; }
      .settings-budget-grid { grid-template-columns: repeat(2, 1fr); }

      .settings-user-active { display: none; }
    }
""".trimIndent()

val SettingsStyles = FC<Props> {
    style {
        +settingsStyles
    }
}
